var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saoma"},[_c('qrcode-stream',{staticStyle:{"height":"100vh","width":"100vw"},on:{"decode":_vm.onDecode,"init":_vm.onInit}},[_c('div',[_c('div',{staticClass:"qr-scanner"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"angle"})])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }